// extracted by mini-css-extract-plugin
export default {"bulletItem":"styles_bulletItem__Chgn3","check":"styles_check__3rthJ","checkCircle":"styles_checkCircle__1kR+M","spin":"styles_spin__oR13Z"};